import { render, staticRenderFns } from "./RelatedAccessory.vue?vue&type=template&id=2eaabfb5&scoped=true&"
import script from "./RelatedAccessory.vue?vue&type=script&lang=ts&"
export * from "./RelatedAccessory.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedAccessory.vue?vue&type=style&index=0&id=2eaabfb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaabfb5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsImageOrFallback: require('/var/www/packages/theme/components/atoms/ImageOrFallback.vue').default,AtomsFavoriteButton: require('/var/www/packages/theme/components/atoms/FavoriteButton.vue').default,AtomsRatingStarsBar: require('/var/www/packages/theme/components/atoms/RatingStarsBar.vue').default,AtomsAddToCartButton: require('/var/www/packages/theme/components/atoms/AddToCartButton.vue').default,AtomsPrice: require('/var/www/packages/theme/components/atoms/Price.vue').default})
